import { z } from "zod";

import { GenericBillingPlanDtoSchema } from "../../../dtos/subscriptions";

export const GetAppSubscriptionsResponseBodySchema = z.object({
  shopifyPlans: GenericBillingPlanDtoSchema.array(),
  stripePlans: GenericBillingPlanDtoSchema.array(),
});

export type GetAppSubscriptionsResponseBodyType = z.infer<
  typeof GetAppSubscriptionsResponseBodySchema
>;
